import styled from 'styled-components'

export const Results = styled.section`
  animation: researchResultsReveal 0.28s ease both;
  @keyframes researchResultsReveal { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: none; } }
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;
export const ResultsHeader = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
`;
export const ResultsCount = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, sans-serif;
  font-size: 20px;
  font-weight: 700;
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  @media (max-width: 1160px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 650px) { grid-template-columns: 1fr; }
`;
export const Card = styled.article`
  min-width: 0;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.colors.cardSurface};
  box-shadow: ${({ theme }) => theme.palette.colors.cardShadow};
  transition: border-color 0.18s ease, transform 0.18s ease;
  &:hover, &:focus-within { border-color: ${({ theme }) => theme.palette.colors.borderStrong}; transform: translateY(-2px); }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
export const CardHeader = styled.div`
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
export const Identity = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: ${({ end }) => end ? 'flex-end' : 'flex-start'};
  gap: 5px;
`;
export const Logo = styled.img`
  width: ${({ $source }) => $source ? '78px' : 'auto'};
  max-width: ${({ $source }) => $source ? '78px' : '118px'};
  height: ${({ $source }) => $source ? '32px' : '42px'};
  object-fit: ${({ $source }) => $source ? 'cover' : 'contain'};
  object-position: ${({ $source }) => $source ? 'center' : 'right center'};
  filter: ${({ $logoKey, theme }) => theme.mode === 'dark' && ['fda', 'brainsway', 'neurosoft'].includes(String($logoKey || '').trim().toLowerCase())
    ? 'brightness(0) invert(1)'
    : 'none'};
  border-radius: 3px;
`;
export const LogoFallback = styled.span`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;
export const DateText = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Lato, sans-serif;
  font-size: 12px;
`;
export const CardBody = styled.div`
  flex: 1;
  padding-top: 14px;
`;
export const ResultTitle = styled.button`
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Gilroy, sans-serif;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.28;
  text-align: left;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  &:hover { color: ${({ theme }) => theme.palette.blue.main}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 4px; }
`;
export const Contributor = styled.p`
  margin: 10px 0 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
export const Conditions = styled.div`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;
export const Condition = styled.span`
  padding: 4px 7px;
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Poppins, sans-serif;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;
export const MetaRow = styled.div`
  margin-top: 11px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
`;
export const Citation = styled.span`
  color: ${({ theme }) => theme.palette.colors.subdued};
  font-family: Lato, sans-serif;
  font-size: 13px;
  text-transform: capitalize;
`;
export const Journal = styled.p`
  margin: 8px 0 0;
  color: ${({ theme }) => theme.palette.colors.muted};
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-style: italic;
  line-height: 1.35;
`;
export const CardFooter = styled.footer`
  min-height: 25px;
  padding-top: 13px;
  border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
`;
export const SourceLink = styled.a`
  color: ${({ theme }) => theme.palette.blue.main};
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 3px; }
`;
export const LoadMore = styled.div`
  padding: 28px 0 4px;
  display: flex;
  justify-content: center;
`;
